import { ClipboardList, MessageSquare } from "lucide-react";
import { Link } from "wouter";
import { PageHeader } from "@/components/page-header";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useAuth } from "@/hooks/use-auth";

export default function EmployeeDashboard() {
  const { employee } = useAuth();

  return (
    <div className="space-y-6">
      <PageHeader
        title={`Olá, ${employee?.fullName?.split(" ")[0] || "Colaborador"}`}
        description="Bem-vindo ao portal do colaborador"
      />

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <Link href="/my-surveys">
          <Card className="hover-elevate cursor-pointer h-full">
            <CardHeader>
              <div className="flex items-center gap-3">
                <div className="p-2 rounded-lg bg-primary/10">
                  <ClipboardList className="h-6 w-6 text-primary" />
                </div>
                <div>
                  <CardTitle className="text-lg">Pesquisas Pulse</CardTitle>
                  <CardDescription>Responda pesquisas de clima</CardDescription>
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Participe das pesquisas de clima e ajude a melhorar nosso ambiente de trabalho.
              </p>
            </CardContent>
          </Card>
        </Link>

        <Card className="h-full opacity-50">
          <CardHeader>
            <div className="flex items-center gap-3">
              <div className="p-2 rounded-lg bg-muted">
                <MessageSquare className="h-6 w-6 text-muted-foreground" />
              </div>
              <div>
                <CardTitle className="text-lg">Minhas Avaliações</CardTitle>
                <CardDescription>Em breve</CardDescription>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Visualize e acompanhe suas avaliações de desempenho.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
